import { ExportType } from '../interfaces';
import { SplitPayment, CreateSplitPayment, SplitPaymentFilters } from './interfaces';

export enum SplitPaymentsActionType {
  GET_SPLIT_PAYMENTS = 'SPLIT_PAYMENTS/GET_SPLIT_PAYMENTS',
  GET_SPLIT_PAYMENTS_SUCCESS = 'SPLIT_PAYMENTS/GET_SPLIT_PAYMENTS_SUCCESS',
  GET_SPLIT_PAYMENTS_ERROR = 'SPLIT_PAYMENTS/GET_SPLIT_PAYMENTS_ERROR',
  POST_CREATE_SPLIT_PAYMENT = 'SPLIT_PAYMENTS/POST_CREATE_SPLIT_PAYMENT',
  POST_CREATE_SPLIT_PAYMENT_SUCCESS = 'SPLIT_PAYMENTS/POST_CREATE_SPLIT_PAYMENT_SUCCESS',
  POST_CREATE_SPLIT_PAYMENT_ERROR = 'SPLIT_PAYMENTS/POST_CREATE_SPLIT_PAYMENT_ERROR',
  INVITE_TO_COLLABORATE = 'SPLIT_PAYMENTS/INVITE_TO_COLLABORATE',
  VALIDATE_MERCHANT_COLLABORATOR = 'SPLIT_PAYMENTS/VALIDATE_MERCHANT_COLLABORATOR',
  VALIDATE_MERCHANT_COLLABORATOR_SUCCESS = 'SPLIT_PAYMENTS/VALIDATE_MERCHANT_COLLABORATOR_SUCCESS',
  VALIDATE_MERCHANT_COLLABORATOR_ERROR = 'SPLIT_PAYMENTS/VALIDATE_MERCHANT_COLLABORATOR_ERROR',
  SELECT_USER_TYPE = 'SPLIT_PAYMENTS/SELECT_USER_TYPE',
  PERFORM_COLLABORATION_ACTION = 'SPLIT_PAYMENTS/PERFORM_COLLABORATION_ACTION',
  PERFORM_COLLABORATION_ACTION_SUCCESS = 'SPLIT_PAYMENTS/PERFORM_COLLABORATION_ACTION_SUCCESS',
  PERFORM_COLLABORATION_ACTION_ERROR = 'SPLIT_PAYMENTS/PERFORM_COLLABORATION_ACTION_ERROR',
  CANCEL_COLLABORATION = 'SPLIT_PAYMENTS/CANCEL_COLLABORATION',
  CANCEL_COLLABORATION_SUCCESS = 'SPLIT_PAYMENTS/CANCEL_COLLABORATION_SUCCESS',
  CANCEL_COLLABORATION_ERROR = 'SPLIT_PAYMENTS/CANCEL_COLLABORATION_ERROR',
  SELECT_COLLABORATION = 'SPLIT_PAYMENTS/SELECT_COLLABORATION',
  SHOW_EXPORT_SPLITS = 'SPLIT_PAYMENTS/SHOW_EXPORT_SPLITS',
  EXPORT_SPLITS = 'SPLIT_PAYMENTS/EXPORT_SPLITS',
  EXPORT_SPLITS_SUCCESS = 'SPLIT_PAYMENTS/EXPORT_SPLITS_SUCCESS',
  EXPORT_SPLITS_ERROR = 'SPLIT_PAYMENTS/EXPORT_SPLITS_ERROR',
}

export const getSplitPayments = (page: number, filters?: SplitPaymentFilters) => ({
  type: SplitPaymentsActionType.GET_SPLIT_PAYMENTS,
  page,
  filters,
});

export const getSplitPaymentsSuccess = (response: any) => ({
  type: SplitPaymentsActionType.GET_SPLIT_PAYMENTS_SUCCESS,
  response,
});

export const getSplitPaymentsError = (error: any) => ({
  type: SplitPaymentsActionType.GET_SPLIT_PAYMENTS_ERROR,
  error,
});

export const inviteToCollaborate = () => ({
  type: SplitPaymentsActionType.INVITE_TO_COLLABORATE,
});

export const validateMerchantCollaborator = (payload: CreateSplitPayment) => ({
  type: SplitPaymentsActionType.VALIDATE_MERCHANT_COLLABORATOR,
  payload,
});

export const validateMerchantCollaboratorSuccess = (response: SplitPayment) => ({
  type: SplitPaymentsActionType.VALIDATE_MERCHANT_COLLABORATOR_SUCCESS,
  response,
});

export const validateMerchantCollaboratorError = (error: any) => ({
  type: SplitPaymentsActionType.VALIDATE_MERCHANT_COLLABORATOR_ERROR,
  error,
});

export const postCreateSplitPayment = () => ({
  type: SplitPaymentsActionType.POST_CREATE_SPLIT_PAYMENT,
});

export const postCreateSplitPaymentSuccess = (response: SplitPayment) => ({
  type: SplitPaymentsActionType.POST_CREATE_SPLIT_PAYMENT_SUCCESS,
  response,
});

export const postCreateSplitPaymentError = (error: any) => ({
  type: SplitPaymentsActionType.POST_CREATE_SPLIT_PAYMENT_ERROR,
  error,
});

export const selectUserType = (userType: string) => ({
  type: SplitPaymentsActionType.SELECT_USER_TYPE,
  userType,
});

export const performCollaborationAction = (id: number, action: string) => ({
  type: SplitPaymentsActionType.PERFORM_COLLABORATION_ACTION,
  action,
  id,
});

export const performCollaborationActionSuccess = () => ({
  type: SplitPaymentsActionType.PERFORM_COLLABORATION_ACTION_SUCCESS,
});

export const performCollaborationActionError = (error: any) => ({
  type: SplitPaymentsActionType.PERFORM_COLLABORATION_ACTION_ERROR,
  error,
});

export const cancelCollaboration = (id: number) => ({
  type: SplitPaymentsActionType.CANCEL_COLLABORATION,
  id,
});

export const cancelCollaborationSuccess = () => ({
  type: SplitPaymentsActionType.CANCEL_COLLABORATION_SUCCESS,
});

export const cancelCollaborationError = (error: any) => ({
  type: SplitPaymentsActionType.CANCEL_COLLABORATION_ERROR,
  error,
});

export const selectCollaboration = (collaborationId: number) => ({
  type: SplitPaymentsActionType.SELECT_COLLABORATION,
  collaborationId,
});

export const showExportSplits = (show: boolean) => ({
  type: SplitPaymentsActionType.SHOW_EXPORT_SPLITS,
  show,
});

export const exportSplits = (filter: string, type: ExportType, collaborationId: number) => ({
  type: SplitPaymentsActionType.EXPORT_SPLITS,
  filter,
  collaborationId,
  exportType: type,
});

export const exportSplitsSuccess = (response: any) => ({
  type: SplitPaymentsActionType.EXPORT_SPLITS_SUCCESS,
  response,
});

export const exportSplitsError = (error: any) => ({
  type: SplitPaymentsActionType.EXPORT_SPLITS_SUCCESS,
  error,
});
